import AdminEventLineScanFinish from './line-scan-finish';

export default AdminEventLineScanFinish;